import { HashRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import PayStatus from "./components/PayStatus";
import PayCancel from "./components/PayCancel";
import PayFailed from "./components/PayFailed";
import RefundPolicy from "./pages/RefundPolicy";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

function App() {
  return (
      <Router basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/status" element={<PayStatus />} />
          <Route path="/payment/cancel" element={<PayCancel />} />
          <Route path="/payment/failed" element={<PayFailed />} />
          {/* <Route path="/booking/cancel" element={<div>Booking Cancelled.</div>} /> */}
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
  );
}

export default App;
